import { useMemo } from 'react';
import { useMap } from 'react-map-gl';

import { WorkspaceTracker } from '@/lib/analytics/trackers/WorkspaceTracker';
import { useApp, useProfile, useWorkspace } from '@/lib/contexts';
import { useMapStore } from '@/lib/store';

export function useWorkspaceTracker(): WorkspaceTracker | null {
  const profile = useProfile();
  const workspace = useWorkspace().workspace;
  const mapMode = useMapStore((state) => state).mapMode;
  const insightsDrawerType = useApp().state.drawer?.type || null;
  const { plotMap: map } = useMap();
  const zoomLevel = map?.getZoom();

  return useMemo(
    () =>
      profile && workspace
        ? new WorkspaceTracker({
            user: profile,
            workspace: workspace,
          })
        : null,
    [useProfile()?.id, useWorkspace().workspace]
  );
}
